import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {

  transform(dateString: string): string {
    if (!dateString) return '';

   const formattedString = dateString.replace(
      /^(\d{4})-(\d{2})-(\d{2})T(\d{2})(\d{2})(\d{2})$/,
      '$1-$2-$3T$4:$5:$6Z'
    );

    // Create a Date object with the UTC-represented string
    const utcDate = new Date(formattedString);

    // Return the date formatted to the user's local machine time
    return utcDate.toLocaleString(); // Adjusts automatically to the user's timezone
  }

}